import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import {useAppState} from '@stores/AppStateContext';
import type {ClientUser, WorkspaceUser} from '../../../../API';
import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {DeleteIcon} from '../../../components/icons/DeleteIcon';
import {GroupIcon} from '../../../components/icons/GroupIcon';
import {MODALS} from '../../../screens/modals/modal-names';
import {ContextMenuInterface} from '../ContextMenuInterface';

export interface WsMemberRowOptionsProps extends ContextMenuInterface {
    user: ClientUser;
    wsUser: WorkspaceUser;
}

export const WsMemberRowOptions = observer(({handleClose, isDark, user, wsUser}: WsMemberRowOptionsProps) => {
    const appState = useAppState();

    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                {
                    text: intl.get('common.remove').d('Remove'),
                    Icon: DeleteIcon,
                    onClick: () => {
                        appState.setContextMenu(null);
                        appState.setModal({name: MODALS.REMOVE_USER_FROM_WORKSPACE, params: {user, wsUser}});
                    },
                },
                {
                    text: intl.get('members.context.assignRoles').d('Assign Roles'),
                    Icon: GroupIcon,
                    onClick: () => {
                        appState.setContextMenu(null);
                        appState.setModal({name: MODALS.MEMBER_ROLES_EDIT, params: {userId: user.id}});
                    },
                },
            ]}
        />
    );
});
